import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type JobCapturedInformationViewModel } from '@/features/jobs/details/JobCapturedInformationViewModel'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'

export interface CapturedInformationLoadContainerProps {
  vm: JobCapturedInformationViewModel
  /**
   * Shown instead of a spinner while the captured information first loads.
   */
  skeleton?: ReactNode
  children: ReactNode
}

/**
 * Shows the captured information once the checklist has loaded, and keeps
 * showing it while the checklist refetches.
 */
export const CapturedInformationLoadContainer = observer(
  function CapturedInformationLoadContainer({
    vm,
    skeleton,
    children,
  }: CapturedInformationLoadContainerProps) {
    return vm.fetch.match({
      pending: () =>
        vm.isRevalidating ? (
          <>{children}</>
        ) : (
          (skeleton ?? <ContentLoading size="section" />)
        ),
      rejected: (err) => (
        <ContentError
          size="section"
          title="Error loading checklist."
          error={err}
        />
      ),
      resolved: () => <>{children}</>,
    })
  },
)
